import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      gap: theme.spacing(0.25),
      backgroundColor: COLORS.gray.white,
      border: theme.shape.borderGray60,
      borderRadius: '50px',
      borderBottomLeftRadius: 0,
      boxShadow: theme.shape.boxShadowMedium,
      padding: theme.spacing(0.5, 0.75),
      color: COLORS.primary.active,

      transition: theme.transitions.create(['border-color', 'background-color'], {
        duration: theme.transitions.duration.shortest,
      }),

      '&:hover': {
        backgroundColor: COLORS.gray.white,
        borderColor: COLORS.gray.gray50,
      },

      '&[disabled]': {
        boxShadow: 'none',
        color: COLORS.gray.gray50,
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),

      '& rect': {
        fill: COLORS.gray.gray80,
      },
      '& path': {
        fill: COLORS.primary.active,
      },
    },
  }),
  { name: 'AddInfoButton' }
);
